import { resolveIconHref } from "../resolve-icon.js";
import type { CSSProperties } from "react";
import { tv } from "tailwind-variants";

const spriteIconSizes = [
	"extraSmall",
	"small",
	"medium",
	"large",
	"extraLarge",
] as const;

export type SpriteIconSize = (typeof spriteIconSizes)[number];

type SpriteIconProps = {
	icon: string;
	iconSize?: SpriteIconSize;
	className?: string;
	style?: CSSProperties;
};

export function tryGetIconSize(value?: string | null): SpriteIconSize {
	return spriteIconSizes.includes(value as SpriteIconSize)
		? (value as SpriteIconSize)
		: "medium";
}

export const spriteIcon = tv({
	base: ["icon"],
	variants: {
		size: {
			extraSmall: "size-1",
			small: "size-5",
			medium: "size-6",
			large: "size-7",
			extraLarge: "size-8",
			fullWidth: "size-4",
		},
	},
	defaultVariants: {
		size: "medium",
	},
});

export default function UmbSpriteIcon({
	icon,
	iconSize,
	className,
	style,
}: SpriteIconProps) {
	return (
		<svg
			className={spriteIcon({
				size: iconSize,
				className,
			})}
			style={style}
			aria-hidden="true"
		>
			<use
				href={resolveIconHref(icon)}
			/>
		</svg>
	);
}
